module.exports = __webpack_public_path__ + "3a3eb0f2bf0ffd8f5201303fa8383677.svg";